<template>
    <v-autocomplete
      v-model="select"
      :loading="loading"
      :items="items"
      :search-input.sync="search"
      cache-items
      class="mx-3"
      flat
      hide-no-data
      hide-details
      label="Quote Lookup"
      solo-inverted
    ></v-autocomplete>
</template>

<script>
import _ from 'lodash';

export default {
  data() {
    return {
      loading: false,
      items: [],
      search: null,
      select: null,
    };
  },
  watch: {
    search(val) {
      if (val && val !== this.select) {
        this.querySelections(val);
      }
    },
    select() {
      this.$emit('searched', this.select);
    },
  },
  methods: {
    querySelections: _.debounce(function (v) {
      if (v.match(/^[a-zA-Z]+$/)) {
        this.loading = true;
        let url = `https://sandbox.tradier.com/v1/markets/lookup?q=${v}`;
        url = encodeURIComponent(url);
        this.$http.get(`https://us-central1-beautifulstocks.cloudfunctions.net/cors?url=${url}`, { headers: { 'Access-Control-Allow-Origin': '*' } }).then((data) => {
          if (Array.isArray(data.data.securities.security)) {
            this.items = data.data.securities.security.map(sec => ({
              text: `${sec.symbol} - ${sec.description}`,
              value: sec.symbol,
            }));
          } else {
            this.items = [{
              text: `${data.data.securities.security.symbol} - ${data.data.securities.security.description}`,
              value: data.data.securities.security.symbol,
            }];
          }
        }).catch(() => {

        }).finally(() => { this.loading = false; });
      }
    }, 250),
  },
};
</script>
